module.exports = __webpack_public_path__ + "static/media/checkbox_checked_box.1fc17dc1.svg";